class FirmnessDiagramLine {
  constructor(container) {
    this.lineSVG = container.querySelector('.MSFSFirmnessDiagram__Line');
    this.linePath = this.lineSVG.querySelector('path');

    // Used as a template for string replacement
    this.d = this.linePath.getAttribute('d');

    this.currentSPosition = 240.684;

    try {
      this.positions = JSON.parse(this.lineSVG.dataset.positions);
    } catch(err) {
      console.error('Positions format incorrect, please double check customizer settings', err);
      this.positions = [140, 240.684, 320];
    }

    this.animating = false;

    // Current animation request id, used to cancel the previous request
    this.currentRequest;
  }

  animateToPosition(index) {
    // Recalculate current d in path
    const currD = this.linePath.getAttribute('d');
    this.currentSPosition = parseFloat(this.getFirstSValue(currD));

    // Get deltaS
    const position = this.positions[index];
    const deltaS = position - this.currentSPosition;

    this.animate({
      timing: this.easeInOut,
      draw: (progress) => {
        const newS = parseFloat(this.currentSPosition) + (progress * deltaS);
        this.setSValue(newS);
      },
      duration: 400,
      onFinished: () => {
        this.currentSPosition = position;
      },
    });
  }

  getFirstSValue(dAttribute) {
    const regex = /s([\d\.]+)/;
    return dAttribute.match(regex)[1];
  }

  setSValue(value) {
    const fixedValue = value.toFixed(3);
    const regex = /s([\d\.]+)/;
    const newD = this.d.replace(regex, 's' + fixedValue);
    this.linePath.setAttribute('d', newD);
  }

  easeInOut(timeFraction) {
    return .5*(Math.sin((timeFraction - .5)*Math.PI) + 1);
  }

  animate({ timing, draw, duration, onFinished }) {
    if (this.animating) {
      cancelAnimationFrame(this.currentRequest);
    }

    this.animating = true;
    let start = performance.now();

    const animate = (time) => {
      // timeFraction goes from 0 to 1
      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) timeFraction = 1;
  
      // Calculate the current animation state
      let progress = timing(timeFraction);
  
      draw(progress);
  
      if (timeFraction < 1) {
        this.currentRequest = requestAnimationFrame(animate.bind(this));
      } else {
        if (onFinished) {
          onFinished();
          this.animating = false;
        }
      }
    }
    this.currentRequest = requestAnimationFrame(animate.bind(this));
  }
}

class MSFSSection extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }
  
    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.waitForStylesheetAndLoad();
    }
  }
  
  cacheElements() {
    //this.firmnessDiagram = this.querySelector('.MSFSFirmnessDiagram');
    this.triggers = this.querySelectorAll('.MSFSSection__MobileDrawerTrigger');
    this.panels = this.querySelectorAll('.MSFSSection__ItemPanel');

    //this.firmnessDiagramLine = new FirmnessDiagramLine(this);

    // Debug object exposed globally to help position the line in the customizer
    //window.dfirmnessdiagramline = this.firmnessDiagramLine;

    this.mql = window.matchMedia('(max-width: 768px)');
    this.isShowingMobileView = this.mql.matches;
  }

  waitForStylesheetAndLoad() {
    if (document.readyState == 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => {
        this.init();
      });
    }
  }

  init() {
    this.mql.addListener(this.update.bind(this));
    this.initSwipers();
    this.initDrawers();
    this.showViewBasedOnWidth();
  }

  /**
   * Drawers should be active on mobile only
   */
  update(e) {
    this.isShowingMobileView = e.matches;
    this.showViewBasedOnWidth();
  }
  
  showViewBasedOnWidth() {
    if (this.isShowingMobileView) {
      this.showMobileView();
    } else {
      this.showDesktopView();
    }
  }

  initSwipers() {
    this.surfaceSwiper = new Swiper('.MSFSSurfaceSwiper.swiper-container', {
      slidesPerView: 2.3,
      roundLengths: true,
      centeredSlides: true,
      initialSlide: 1,
      navigation: {
        nextEl: '.MSFSSurfaceSwiper__Nav .swiper-button-next',
        prevEl: '.MSFSSurfaceSwiper__Nav .swiper-button-prev',
      },
      pagination: {
        el: '.MSFSSurfaceSwiper__Pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {}
    });

    this.firmnessSwiper = new Swiper('.MSFSFirmnessSwiper.swiper-container', {
      slidesPerView: 1,
      roundLengths: true,
      centeredSlides: true,
      navigation: {
        nextEl: '.MSFSFirmnessSwiper__Nav .swiper-button-next',
        prevEl: '.MSFSFirmnessSwiper__Nav .swiper-button-prev',
      },
      pagination: {
        el: '.MSFSFirmnessSwiper__Pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {},
    });

    const numFirmnessSlides = this.querySelectorAll('.MSFSFirmnessSlide').length;
    if (numFirmnessSlides <= 1) {
      const footerNavEls = this.querySelector('.MSFSFirmnessSwiper__Footer');
      footerNavEls.style.display = 'none';
    }
  }

  showMobileView() {
    // Set height values to open panels so that css transitions can happen
    const openPanels = this.querySelectorAll('.MSFSSection__ItemPanel:not(.MSFSSection__ItemPanel--startClosedOnMobile)');
    openPanels.forEach(p => {
      p.style.height = p.scrollHeight + 'px';
    });

    // Set default state by checking for the class
    // 'MSFSSection__ItemPanel--startClosedOnMobile'
    const closedPanels = this.querySelectorAll('.MSFSSection__ItemPanel--startClosedOnMobile');
    closedPanels.forEach(p => {
      p.style.height = '0px';
      p.classList.remove('MSFSSection__ItemPanel--startClosedOnMobile');
    });
  }

  showDesktopView() {
    this.panels.forEach(p => p.style.removeProperty('height'));
  }

  /**
   * Mobile only drawers
   */
  initDrawers() {
    this.triggers.forEach(trigger => trigger.addEventListener('click', (e) => {
      const category = trigger.dataset.category;
      const matchingPanel =
        Array.from(this.panels).find(p => p.dataset.category === category);

      NUtils.slideToggle(matchingPanel);

      NUtils.toggleBooleanAttribute(trigger, 'aria-expanded');

      this.surfaceSwiper.update();
      this.firmnessSwiper.update();
    }));
  }
}
customElements.define('msfs-section', MSFSSection);
